import { addElementsToLayout } from "src/app/generator-data/functions/addElementsToLayout";
import { addHeaderToLayout } from "./addHeaderToLayout";

export const addCreatorInsightsToLayout = (
  gridElements,
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.creatorsInsights;

  Object.keys(campaigns).forEach((key) => {
    const campaign = campaigns[key];

    const {
      project: { title },
    } = campaign;

    if (!aggregation && key !== "aggregated") {
      addHeaderToLayout(`creator-insights-${title}`, newLayout, format, 3);
    }

    const gridElementsToAdd = gridElements.filter(
      (item) =>
        item.gridBoxType === "creator-insights" && item.campaignId === key,
    );
    addElementsToLayout(gridElementsToAdd, newLayout, format, []);
  });
};
